<router-outlet></router-outlet>

<div id="logoutFrames"></div>

<div kendoDialogContainer></div>
